<template lang="pug">
  .wrapper-locker
    h2 gestão de travamentos

    .slider
      RadioSlider(
        :items="modes.items",
        :current="modes.items.findIndex(i => i.id === modes.selected.id)",
        @selected="changedMode"
      )

    PMultiSelect(:useState="modes.selected.state", labelItem="name"
      :title="modes.selected.name" :useCommon="modes.selected.common" ref="select")

    PSelect(:options="months", useState="locker/month", labelItem="name"
      title="mês"  :allowEmpty="false")

    PSelect(:options="years", useState="locker/year", labelItem="name"
      title="ano"  :allowEmpty="false")

    .button
      PButton(color="success" size="md" block :loading="loading" @click="loadData" :disabled="!anySelected") buscar

    .steps
      LockSteps(@changed="changedStep", :currentStep="step" :permissions="permissions" :mode="modes.selected.id")

    .table
      LockTable(:mode="step" ref="table" @updateData="loadData" :permissions="permissions")

</template>

<script>
import { mapState } from 'vuex'
import { range } from 'src/utils'
import LockSteps from './LockSteps'
import LockTable from './LockTable'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  name: 'LockerList',
  components: {LockSteps, LockTable},
  mounted () {
    setAmplitudeEvent('lista gestao de travamentos', {})
  },
  created () {
    this.$store.commit('locker/resetState')
  },
  data () {
    const dataAtual = new Date()
    const anoAtual = dataAtual.getFullYear()
    const anoInicial = 2014
    return {
      permissions: {
        unlockerAsk: this.$hasPermission({ module: 'unlockerask', action: 'post', hide: true }),
        confirmLock: this.$hasPermission({ module: 'lockconfirmation', action: 'post', hide: true }),
        rejectLock: this.$hasPermission({ module: 'lockconfirmation', action: 'post', hide: true }),
        doLock: this.$hasPermission({ module: 'locker', action: 'post', hide: true }),
        doUnilateralLock: this.$hasPermission({ module: 'unilateralcloses', action: 'post', hide: true }),
        doUnlocker: this.$hasPermission({ module: 'unlocker', action: 'post', hide: true })
      },
      step: 'notLocked',
      months: range(1, 12).map(i => ({name: i, id: i})),
      years: range(anoInicial, anoAtual).reverse().map(i => ({name: i, id: i})),
      modes: {
        selected: { name: this.$ws('company'), id: 'companies', state: 'locker/companies', common: 'companies/onlyActive' },
        items: [
          { name: this.$ws('company'), id: 'companies', state: 'locker/companies', common: 'companies/onlyActive' },
          { name: this.$ws('employee'), id: 'employees', state: 'locker/employees', common: 'employees/onlyNotFired' },
          { name: this.$ws('employer'), id: 'employers', state: 'locker/employers', common: 'employers' }
        ]
      },
      loadedData: []
    }
  },
  computed: {
    ...mapState('locker', ['loading']),
    anySelected () {
      const {employers, companies, employees} = this.$store.state.locker
      return [...employees.selected, ...companies.selected, ...employers.selected].length >= 1
    }
  },
  methods: {
    loadData () {
      this.$store.dispatch('locker/loadData', {
        mode: this.modes.selected.id
      })
    },
    changedMode (mode) {
      this.modes.selected = mode
      this.$refs.select.open()
    },
    changedStep (step) {
      this.$refs.table.close()
      this.step = step
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper-locker {
  display: grid;
  grid-template-columns: 1.5fr 2fr 80px 100px 0.5fr;
  grid-column-gap: 10px;

  h2 {
    grid-column: 1/6;
    text-align: center;
  }

  .slider {
    align-self: flex-end;
    margin-bottom: 13px;
  }

  .button {
    align-self: flex-end;
    margin-bottom: 16px;
  }

  .steps, .table {
    grid-column: 1/6;
  }
}
</style>
